import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import dynamic from 'next/dynamic';

import ShortForm from 'patterns/ShortForm/ShortForm';
import ProductPageOpenFormSection from 'patterns/ProductPageOpenFormSection/ProductPageOpenFormSection';
import RegistrationUnavailableLanguage from 'patterns/RegistrationUnavailableLanguage/RegistrationUnavailableLanguage';
import useOpenFormVisibility from 'utils/hooks/useOpenFormVisibility/useOpenFormVisibility';
import { DEFAULT_LOCALE } from 'utils/i18nUtils';
import Experiment from '@nubank/www-latam-commons/components/Experiment/Experiment';
import { PROGRESSIVE_DISCLOSURE_FORM_V2 } from 'utils/experiments';

const ProgressiveDisclosureForm = dynamic(import('patterns/ProgressiveDisclosureForm/ProgressiveDisclosureForm'), { ssr: false });

function SectionForm({ onFormVisibilityChange }) {
  const { locale } = useIntl();
  const [ref, isFormHidden] = useOpenFormVisibility();

  useEffect(() => {
    onFormVisibilityChange(isFormHidden);
  }, [isFormHidden]);

  return (
    <ProductPageOpenFormSection ref={ref}>
      <ProductPageOpenFormSection.Container
        gridTemplateRows={{ xs: 'auto 14rem 8rem 1fr', md: 'auto 1fr', lg: '1fr' }}
      >
        <ProductPageOpenFormSection.Heading>
          <Typography
            variant="subtitle"
            tag="h1"
            color="black"
            intlKey="LENDING.PAGE_HEADING.SHORT_FORM.TITLE"
            gutterBottom={1.5}
            intlValues={{ br: <br /> }}
          />
          <Typography
            variant="title"
            tag="h2"
            color="black"
            intlKey="LENDING.PAGE_HEADING.SHORT_FORM.SUBTITLE"
            intlValues={{ br: <br /> }}
          />
        </ProductPageOpenFormSection.Heading>
        <ProductPageOpenFormSection.ImageBlock
          gridRow={{ xs: '2', lg: '1' }}
          margin={{ xs: '1rem 0 0', md: '0 0 2rem', lg: '0' }}
          srcSet={{
            xs: 'woman-with-iphone/woman-with-iphone-short-form@0.5x.jpg',
            md: 'woman-with-iphone/woman-with-iphone-short-form@0.75x.jpg',
            lg: 'woman-with-iphone/woman-with-iphone-short-form@1x.jpg',
          }}
        />
        <ProductPageOpenFormSection.FormBlock>
          {locale === DEFAULT_LOCALE ? (
            <Experiment id={PROGRESSIVE_DISCLOSURE_FORM_V2.id}>
              <Experiment.Original>
                <ShortForm />
              </Experiment.Original>
              <Experiment.Variant id={PROGRESSIVE_DISCLOSURE_FORM_V2.emailsFieldsForm}>
                <ProgressiveDisclosureForm completeFormName="completeFormB" />
              </Experiment.Variant>
              <Experiment.Variant
                id={PROGRESSIVE_DISCLOSURE_FORM_V2.emailFieldConfirmationStepForm}
              >
                <ProgressiveDisclosureForm completeFormName="completeFormC" />
              </Experiment.Variant>
            </Experiment>
          ) : (
            <RegistrationUnavailableLanguage isOpenForm isShortForm />
          )}
        </ProductPageOpenFormSection.FormBlock>
      </ProductPageOpenFormSection.Container>
    </ProductPageOpenFormSection>
  );
}

SectionForm.propTypes = {
  onFormVisibilityChange: PropTypes.func.isRequired,
};

export default React.memo(SectionForm);
